import {
  FETCH_SALES_RESTAURANTS,
  FETCH_SALES_RESTAURANTS_SUCCESS,
  FETCH_SALES_RESTAURANTS_FAIL,
  FETCH_SALES_ANALYTICS,
  FETCH_SALES_ANALYTICS_SUCCESS,
  FETCH_SALES_ANALYTICS_FAIL,
  FETCH_SALES_ANALYTICS_SKIP,
  SET_SALES_ANALYTICS_FILTERS,
  CLEAR_SALES_ANALYTICS,
} from '../actions/salesAnalytics';
import { trimSalesAnalyticsCache } from '../../utils/salesAnalytics';
import { getDefaultDateRangeLast7Days } from '../../utils/cstDate';

const defaultDateRange = getDefaultDateRangeLast7Days();

const initialState = {
  restaurants: [],
  restaurantsLoading: false,
  restaurantsLoaded: false,
  restaurantsError: null,

  analytics: null,
  loading: false,
  error: null,
  activeCacheKey: null,
  fromCache: false,
  lastFetchedAt: null,

  dateRange: {
    start: defaultDateRange.start,
    end: defaultDateRange.end,
    label: defaultDateRange.label,
  },
  selectedRestaurantIds: [],
  groupBy: '',
  chartView: 'bar',

  cache: {},
  cacheKeys: [],
};

export default function salesAnalyticsReducer(state = initialState, action) {
  switch (action.type) {
    case FETCH_SALES_RESTAURANTS:
      return {
        ...state,
        restaurantsLoading: !state.restaurantsLoaded,
        restaurantsError: null,
      };

    case FETCH_SALES_RESTAURANTS_SUCCESS: {
      const restaurants = action.payload?.restaurants || [];
      const selectedRestaurantIds =
        state.selectedRestaurantIds.length > 0
          ? state.selectedRestaurantIds
          : action.payload?.selectedRestaurantIds || [];

      return {
        ...state,
        restaurants,
        selectedRestaurantIds,
        restaurantsLoading: false,
        restaurantsLoaded: true,
        restaurantsError: null,
      };
    }

    case FETCH_SALES_RESTAURANTS_FAIL:
      return {
        ...state,
        restaurantsLoading: false,
        restaurantsError: action.payload || 'Failed to load restaurants',
      };

    case FETCH_SALES_ANALYTICS: {
      const forceRefresh = Boolean(action.payload?.forceRefresh);
      const hasData = Boolean(state.analytics);

      return {
        ...state,
        // Soft loading: keep existing UI visible while refreshing
        loading: forceRefresh || !hasData,
        error: null,
      };
    }

    case FETCH_SALES_ANALYTICS_SKIP:
      return {
        ...state,
        loading: false,
      };

    case FETCH_SALES_ANALYTICS_SUCCESS: {
      const {
        cacheKey,
        analytics,
        fromCache,
        fetchedAt,
        alreadyActive = false,
      } = action.payload;

      if (alreadyActive && state.activeCacheKey === cacheKey && state.analytics) {
        return {
          ...state,
          loading: false,
          fromCache: true,
        };
      }

      const existingIndex = state.cacheKeys.indexOf(cacheKey);
      const nextKeys =
        existingIndex === -1
          ? [...state.cacheKeys, cacheKey]
          : [...state.cacheKeys.filter((key) => key !== cacheKey), cacheKey];

      const nextCache = {
        ...state.cache,
        [cacheKey]: {
          analytics,
          fetchedAt,
        },
      };

      const trimmed = trimSalesAnalyticsCache(nextCache, nextKeys);

      return {
        ...state,
        loading: false,
        error: null,
        analytics,
        activeCacheKey: cacheKey,
        fromCache: Boolean(fromCache),
        lastFetchedAt: fetchedAt,
        cache: trimmed.cache,
        cacheKeys: trimmed.cacheKeys,
      };
    }

    case FETCH_SALES_ANALYTICS_FAIL:
      return {
        ...state,
        loading: false,
        error: action.payload || 'Failed to load sales analytics',
      };

    case SET_SALES_ANALYTICS_FILTERS:
      return {
        ...state,
        ...action.payload,
      };

    case CLEAR_SALES_ANALYTICS:
      return {
        ...initialState,
        cache: state.cache,
        cacheKeys: state.cacheKeys,
        restaurants: state.restaurants,
        restaurantsLoaded: state.restaurantsLoaded,
        selectedRestaurantIds: state.selectedRestaurantIds,
      };

    default:
      return state;
  }
}
